import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-toggle-filters',
    templateUrl: './toggle-filters.component.html',
    styleUrls: ['./toggle-filters.component.scss'],
    imports: [MatIcon]
})
export class ToggleFiltersComponent implements OnInit, OnDestroy {

    public toggleOpen = true;

    private _body: HTMLElement;
    private _class = 'contentMaximized';

    @Output() toggleStateChange: EventEmitter<boolean> = new EventEmitter();

    constructor() {
        this._body = document.getElementById('body');
    }

    public toggle(){
        if(this.toggleOpen){
            this._body.classList.add(this._class);
        }
        else{
            this._body.classList.remove(this._class);
        }
        this.toggleOpen = !this.toggleOpen;
        this.toggleStateChange.emit(this.toggleOpen);
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this._body.classList.remove(this._class);
    }

}
